import BigNumber from 'bignumber.js';

export function toFixed (val: number | string) {

	return BigNumber(val).toFormat(1, BigNumber.ROUND_UP).toString();

}
